import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageLayout from "Layouts/PageLayout";
import Button from "Components/Button";
import { PrintSizeList } from "Features/Prints";
import { usePrintSizes } from "Apis/PrintSizeApi";
import PrintIcon from "Assets/SVG/PrintIcon";
import Pagination from "../../../Components/Pagination";
import useQueryParams from "../../../Hooks/UseQueryParams";

const Index = () => {
    
    const { t } = useTranslation();

    const [ filter, setFilter ] = useQueryParams();

    const { data: printSizes, isLoading } = usePrintSizes(filter);
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('printSizes')} icon={<PrintIcon />} header={(
            <Button prefix={<PrintIcon fill={"#FFF"} />} text={t('createNewPrintSize')} type={"primary"} onClick={() => navigate("new")} />
        )}>
            <>
                <PrintSizeList printSizes={printSizes?.items} isLoading={isLoading} />

                <Pagination paginatedList={printSizes} onPageChange={newPage => setFilter({page: newPage})} />
            </>
        </PageLayout>
    )
}

export default Index
